import "magnific-popup";

if ($("#rental-edit").length || $("#rental-list").length) {
  if (!HTMLFormElement.prototype.reportValidity) {
    HTMLFormElement.prototype.reportValidity = function () {
      if (this.checkValidity()) return true;
      this.submit();
      return false;
    };
  }

  $("#rental-edit, #rental-list").on("click", ".preview", function (e) {
    e.preventDefault();
    let $this = $(this);
    if ($("form").length != 0 && !$("form")[0].reportValidity()) {
      $("form").find('input[type="submit"]').trigger("click");
      return false;
    } else {
      $this.attr("href", this.href.split("?")[0]); //reset querystring

      var formData = $("#rental-edit > form").serialize();
      $this.attr("href", this.href + "?" + formData);
      window.open($this.attr("href"), "_blank");

      // var formData = $('#rental-edit > form').serialize();
      // $this.attr('href', this.href + "?" + formData)
      // $.magnificPopup.open({
      //     type: 'ajax',
      //     closeOnBgClick: true,
      //     closeBtnInside: true,
      //     closeOnContentClick: true,
      //     items: {
      //         src: $this.attr('href')
      //     },
      //     callbacks: {
      //         parseAjax: function(mfpResponse) {
      //             mfpResponse.data = $(mfpResponse.data).find('#rental.preview');
      //         },
      //         ajaxContentAdded: function() {
      //         }
      //     }
      // }, 0);
    }
  });

  $(".business").on(
    "click",
    "#rental.preview .forbidden, #rental.preview .share a, #rental.preview #social a, #rental.preview .submit ",
    function (e) {
      e.preventDefault();
      e.stopPropagation();
    }
  );
}
